import React, { useEffect, useRef, useCallback } from "react";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import {
    ILojaState,
    saveDadosLoja,
    updateFaseMag,
    contratarFake
} from "../../features/simulacao/loja";

import { initSimulacao, ISimulacaoState } from "../../features/simulacao/simulacao";
import SummaryBox from "../component/SummaryBox";

import globalState from "../../features/global-state";
import { useHookstate } from "@hookstate/core";

export interface ILojaProps {
    loja?: ILojaState
    simulacao: ISimulacaoState
}

const Loja = () => {

    const simulacaoState = useHookstate(globalState.simulacao)
    const lojaState = useHookstate(globalState.faseLoja)

    const tokenMag = lojaState?.tokenMag.get();
    const lojaUrl = lojaState?.lojaUrl.get();

    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        initSimulacao();
        window.addEventListener("message", handleProposalConfirmed);

        return () => {
            window.removeEventListener('message', handleProposalConfirmed);
        };

        // eslint-disable-next-line
    }, []);

    // =========================
    // EXPIRAÇÃO DA SESSÃO (1H)
    // =========================
    useEffect(() => {
        const timeout = setTimeout(function () {
            resetWidget();
            window.location.href = "/Expirada";
        }, 3600000);

        return () => clearTimeout(timeout);
    }, []);

    const isResume = !!simulacaoState.idFaseMag.get();

    const publishInputToWidget = useCallback(() => {
        const json = isResume
            ? {
                token: tokenMag,
                initializer: {
                    type: "resume-workflow",
                    workflowId: simulacaoState.idFaseMag.get()
                }
            }
            : {
                token: tokenMag,
                initializer: {
                    type: "new-workflow",
                    workflowDefinitionId: "EmpresarialGlobalCotacaoPorGrupoSegurado",
                    parameters: {
                        partnershipDocument: simulacaoState.cnpjParceria.get(),
                        producerCode: simulacaoState.codProdutor.get(),
                        representedCode: null,
                        externalId: simulacaoState.idSimulacao?.get().toString(),
                        origin: "SIGAS",
                        customer: simulacaoState.proponente?.cnpj.get()
                            ? {
                                documentType: "Cnpj",
                                document: simulacaoState.proponente.cnpj.get()
                            }
                            : null,
                        susepCodeAssigned: simulacaoState.corretora?.susep.get() ?? null,
                        businessBranchAssigned: simulacaoState.corretora.sucursal?.get(),
                        availableBanks: simulacaoState.corretora?.bancos?.get()
                            ? JSON.parse(JSON.stringify(simulacaoState.corretora.bancos.get()))
                            : null
                    }
                }
            };

        if (window === window.top && iframeRef.current) {
            var quantidadeEnviosToken = 0;
            var intervalEnvioToken = setInterval(function () {
                quantidadeEnviosToken += 1;
                if (quantidadeEnviosToken === 10) {
                    clearInterval(intervalEnvioToken);
                }

                iframeRef.current?.contentWindow?.postMessage(json, "*");
            }, 1000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResume, simulacaoState.get(), tokenMag]);

    function resetWidget() {
        iframeRef.current?.contentWindow?.postMessage({
            event: 'notify',
            property: 'Reset',
            value: null,
        }, '*');
    }

    function handleProposalConfirmed(event: any) {

        if (event.data?.event === 'Workflow:Status') {
            const workflowId = event.data?.data?.workflowId;

            if (workflowId) {
                updateFaseMag(workflowId);
            }
        }

        if (event.data?.event === 'Workflow:Proposal') 
        {
            const retorno = event.data?.data;

            if (!retorno?.success || !retorno?.proposals?.length) return;

            saveDadosLoja({
                dadosRetornoIframe: JSON.stringify(retorno)
            } as ILojaState);
        }

        /*
        var propostas = [];

        //TODO: simplificar logica para evitar mapeamento desnecessário
        event.data.propostas.forEach(proposta => {
            propostas.push(
            {
                fatorComissionamento: proposta.opcaoComissionamento.PercentualCorretagem + proposta.opcaoComissionamento.PercentualProLabore,
                numeroProposta: proposta.numeroProposta,
                premioTotal: proposta.premioTotal,
                modeloProposta: proposta.modeloProposta,
                grupoSegurado: proposta.grupoSegurado,
                linkPDF: proposta.linkPDF,
            })
        });

        saveDadosLoja({
            grupoDePropostas: {
                cnpjCorretora: event.data.dadosOrigem?.cnpjParceria,
                cnpjProponente: event.data.dadosOrigem?.cnpjProponente,
                corretor1: event.data.dadosOrigem?.corretor1,
                identsaveDadosLojaificadorExterno: event.data.dadosOrigem?.identificadorExterno,
                sucursal: event.data.dadosOrigem?.sucursal,
                susepCorretora: event.data.dadosOrigem?.susepCorretora,
                propostas: propostas
            }
        } as ILojaState);
        */
    }

    return (
        <>
            {
                simulacaoState.naoExistePa.get() &&
                <Box sx={{ display: "flex", flexWrap: "wrap", mb: "20px" }}>
                    <Box sx={{ flex: "1 0 0%", pl: "15px", pr: "15px" }}>
                        <Alert severity="info">
                            O PA não foi encontrado na Mongeral.<br />
                            Proceda com a venda normalmente e, após efetivar, notifique a corretora com os dados da cotação.
                        </Alert>
                    </Box>
                </Box>
            }

            {
                //<Row>
                //  <Col md={12}>
                //       <Paper elevation={0}>
                //           <Button variant="contained" color="primary"
                //               onClick={() => contratarFake()}>
                //               CONTRATAR FAKE
                //           </Button>
                //       </Paper>
                //   </Col>
                //</Row>
            }

            <SummaryBox />
            <Paper sx={{ mt: "20px" }}>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ pt: "10px", pl: "15px", pr: "15px" }}>
                        <iframe
                            ref={iframeRef}
                            id="iframe-loja"
                            name="loja"
                            title="Mag"
                            src={lojaUrl}
                            style={{
                                overflow: "hidden",
                                width: "100%",
                                border: "none",
                                minHeight: "820px"
                            }}
                            onLoad={() => {
                                if (!tokenMag) return;

                                const jsonToken = {
                                    event: 'notify',
                                    property: 'Auth',
                                    value: tokenMag
                                };

                                iframeRef.current?.contentWindow?.postMessage(jsonToken, '*');

                                setTimeout(function () {
                                    publishInputToWidget();
                                }, 500);
                            }}
                        />
                    </Box>
                </Box>
            </Paper>
        </>
    );
};

export default Loja
